module.exports = __webpack_public_path__ + "static/media/arrow_left_to_line.fbf62ddc.svg";